module.exports = __webpack_public_path__ + "static/img/planRight7.e7afc468.png";